<template>
    <div class="col-xl-6">
        <div class="card card-custom gutter-b">
            <!--begin::Body-->
            <div class="card-body pt-4 d-flex flex-column justify-content-between">
                <!--begin::Toolbar-->
                <div class="d-flex justify-content-end">
                    <b-dropdown
                        size="sm"
                        no-caret
                        right
                        variant="hover-light-primary"
                        class="m-2 btn btn-hover-light-primary btn-icon btn-sm"
                    >
                        <template v-slot:button-content>
                            <i class="ki ki-bold-more-hor"></i>
                        </template>
                        <b-dropdown-item
                            :href="'https://instagram.com/' + account.username"
                            target="_blank"
                        >
                            <i class="flaticon-instagram-logo mr-2"></i> View on Instagram
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="emitAnalyse(account)">
                            <i class="fas fa-cogs mr-2"></i> Analyse
                        </b-dropdown-item>
                        <b-dropdown-item @click="emitDelete(account)">
                            <i class="far fa-trash-alt mr-2"></i> Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <!--end::Toolbar-->
                <!--begin::User-->
                <div class="d-flex align-items-center mb-7">
                    <!--begin::Pic-->
                    <div class="flex-shrink-0 mr-4 mt-lg-0 mt-3">
                        <div class="symbol symbol-lg-75">
                            <img alt="Pic" :src="account.profilepic" />
                        </div>
                        <div class="symbol symbol-lg-75 symbol-primary d-none">
                            <span class="font-size-h3 font-weight-boldest">JM</span>
                        </div>
                    </div>
                    <!--end::Pic-->
                    <!--begin::Title-->
                    <div class="d-flex flex-column" style="overflow-wrap: anywhere;">
                        <a
                            @click="emitAnalyse(account)"
                            class="text-dark font-weight-bold text-hover-primary font-size-h5 mb-0"
                            >{{ account.username }}</a
                        >
                        <span
                            class="text-muted font-weight-bold"
                            v-if="account.business_category_name"
                            >{{ account.business_category_name }}</span
                        >
                        <span
                            class="text-muted font-weight-bold"
                            v-if="!account.business_category_name"
                            >Personal Account</span
                        >
                    </div>
                    <!--end::Title-->
                </div>
                <!--end::User-->
                <!--begin::Desc-->
                <p class="mb-7 account-bio">
                    {{ account.bio }}
                </p>
                <span class="mb-7" v-if="account.external_url">
                    <a
                        class="btn btn-outline-primary btn-sm"
                        target="_blank"
                        v-bind:href="account.external_url"
                    >
                        <i class="fas fa-external-link-alt"></i> View website
                    </a>
                </span>
                <!--end::Desc-->
                <!--begin::Info-->
                <div class="mb-7">
                    <div class="d-flex align-items-center rounded p-1 mb-1 mt-1">
                        <span class="mr-5">
                            <i class="fas fa-users text-success"></i>
                        </span>
                        <div class="d-flex flex-column flex-grow-1 mr-2">
                            <a
                                class="font-weight-bold text-dark-75 text-hover-primary font-size-lg"
                            >
                                Followers
                            </a>
                        </div>
                        <span class="font-weight-bolder py-1 font-size-lg text-success">
                            {{ addCommaToNumber(account.followers) }}
                        </span>
                    </div>

                    <div class="separator separator-dashed separator-border-1"></div>

                    <div class="d-flex align-items-center rounded p-1 mb-1 mt-1">
                        <span class="mr-5">
                            <i class="fas fa-user-friends text-primary"></i>
                        </span>
                        <div class="d-flex flex-column flex-grow-1 mr-2">
                            <a
                                class="font-weight-bold text-dark-75 text-hover-primary font-size-lg"
                            >
                                Followings
                            </a>
                        </div>
                        <span class="font-weight-bolder py-1 font-size-lg text-primary">
                            {{ addCommaToNumber(account.followings) }}
                        </span>
                    </div>

                    <div class="separator separator-dashed separator-border-1"></div>

                    <div class="d-flex align-items-center rounded p-1 mb-1 mt-1">
                        <span class="mr-5">
                            <i class="fas fa-images text-warning"></i>
                        </span>
                        <div class="d-flex flex-column flex-grow-1 mr-2">
                            <a
                                class="font-weight-bold text-dark-75 text-hover-primary font-size-lg"
                            >
                                Posts
                            </a>
                        </div>
                        <span class="font-weight-bolder py-1 font-size-lg text-warning">
                            {{ addCommaToNumber(account.postcount) }}
                        </span>
                    </div>

                    <div class="separator separator-dashed separator-border-1"></div>

                    <div class="d-flex align-items-center rounded p-1 mb-1 mt-1">
                        <span class="mr-5">
                            <i class="fas fa-chart-pie text-success"></i>
                        </span>
                        <div class="d-flex flex-column flex-grow-1 mr-2">
                            <a
                                class="font-weight-bold text-dark-75 text-hover-primary font-size-lg"
                            >
                                Engagement
                            </a>
                        </div>
                        <span class="font-weight-bolder py-1 font-size-lg text-success">
                            {{ account.engagement }}%
                        </span>
                    </div>

                    <div class="separator separator-dashed separator-border-1"></div>
                </div>
                <!--end::Info-->
                <b-button
                    class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4"
                    @click="emitAnalyse(account)"
                >
                    Analyse
                </b-button>
            </div>
            <!--end::Body-->
        </div>
    </div>
</template>
<style scoped>
.account-bio {
    white-space: pre-line;
    width: 100%;
}
</style>
<script>
import stringManagement from "@/mixins/stringManagement";
export default {
    name: "AccountBadge2",
    props: ["account", "type"],
    mixins: [stringManagement],
    methods: {
        emitAnalyse(account) {
            this.$emit("getEmitAnalyse", account);
        },

        emitDelete(account) {
            this.$emit("getEmitDelete", account);
        },
    },
};
</script>
